module.exports = __webpack_public_path__ + "img/count_down_text.47ae3aad.png";